import gql from 'graphql-tag'

export const listUsersQuery = gql`
	query listUsers {
		allUsers {
			id
			name
			email
			phone
			isEnabled
      isRootAdmin
      userRoles {
          id
          installationId
          role {
              id
              name
              label
          }
      }
		}
	}
`

export const userById = gql`
    query userById($id: ID!) {
        user(id: $id) {
            id
            name
            email
            phone
            isEnabled
            mfaEnabled
            createdAt
            userRoles {
                id
                installationId
                role {
                    id
                    name
                    label
                }
            }
        }
    }
`;

export const createUserMutation = gql`
	mutation createUser (
		$id: ID
		$name: String!
		$email: String!
		$phone: String!
		$password: String!
    $roleId: ID!
	) {
		createUser(
			user: {
			  id: $id
				isEnabled: true
        roleId: $roleId
				name: $name
				phone: $phone
				email: $email
				password: $password
			}
		) {
			id
		}
	}
`

export const updateUserMutation = gql`
	mutation updateUser (
		$id: ID!
		$name: String!
		$email: String!
		$phone: String!
		$isEnabled: Boolean!
        $mfaEnabled: Boolean
    $roleId: ID
	) {
		updateUser(
			user: {
				id: $id
				name: $name
				email: $email
				phone: $phone
				isEnabled: $isEnabled
                mfaEnabled: $mfaEnabled
        roleId: $roleId
			}
		) {
			name
			email
			phone
			isEnabled
        userRoles {
          id
          installationId
          role {
            id
            name
            label
          }
        }
		}
	}
`

export const updateUserPasswordMutation = gql`
	mutation updatePassword (
		$id: ID!
		$password: String!
	) {
		updateUser(user: { id: $id, password: $password }) {
			id
		}
	}
`

export const rolesQuery = gql`
  query roles {
    roles {
      id
      name
      label
      description
      installationId
      permissions {
        id
        permission
      }
    }
  }
`;

export const roleQuery = gql`
    query role($id: ID!) {
        role(id: $id) {
            id
            name
            label
            description
            installationId
            permissions {
                id
                permission
            }
        }
    }
`;

export const createRoleMutation = gql`
    mutation createRole($input: CreateRoleInput!) {
        createRole(input: $input) {
            id
            name
            label
            description
            installationId
            permissions {
                id
                permission
            }
        }
    }
`;

export const updateRoleMutation = gql`
    mutation updateRole($input: UpdateRoleInput!) {
        updateRole(input: $input) {
            id
            name
            label
            description
            installationId
            permissions {
                id
                permission
            }
        }
    }
`;

export const deleteRoleMutation = gql`
  mutation deleteRole($id: ID!) {
    deleteRole(id: $id)
  }
`;
